import { CompanyData, RolesEnum } from 'modules/authenticate/interfaces';

export const inSuperAdminView = (
  role: RolesEnum | undefined,
  companySelected: CompanyData | null
): boolean => role === RolesEnum.superAdmin && !companySelected;

export const inAdminView = (
  role: RolesEnum | undefined,
  companySelected: CompanyData | null
): boolean => role === RolesEnum.admin && !companySelected;

export const inOperatorView = (
  role: RolesEnum | undefined,
  companySelected: CompanyData | null
): boolean => role === RolesEnum.operator && !companySelected;

export const isClientOperator = (role: RolesEnum | undefined): boolean =>
  !!role && role === RolesEnum.clientOperator;
